import type { FC } from "react";

import { useCurrentStateAndParams } from "@uirouter/react";

import companyAnalysisTrackingService from "app/pages/sales-intelligence/modules/company-analysis/services/tracking/companyAnalysisTrackingService";
import { WEBSITE_ANALYSIS_WIDGET_NAMES } from "app/pages/sales-intelligence/pages/company-analysis/constants";
import { GainAccessButton } from "app/pages/sales-intelligence/common-components/GainAccessButton";
import { EngagementOverviewKpi } from "app/pages/website-performance/components/EngagementOverviewKpi/EngagementOverviewKpi";
import { DEFAULT_HOOKS_MODAL_ID } from "app/pages/workspace/config/stateToWsConfigMap";
import { proNavigator } from "single-spa/react-app/ProNavigator";

export const EngagementOverviewKpiContainerSI: FC = () => {
    const { params } = useCurrentStateAndParams();

    const getCtaLink = () => {
        return {
            href: proNavigator.href("accountreview_website_trafficandengagement", params),
            target: "_self",
            onClick: () => {
                companyAnalysisTrackingService.website.trackWidgetCtaClick(
                    WEBSITE_ANALYSIS_WIDGET_NAMES.trafficEngagement,
                    params.key,
                );
            },
        };
    };
    return (
        <EngagementOverviewKpi
            getCtaLink={getCtaLink}
            unlockHook={{
                component: "WsWebTrafficAndEngagement",
                hookModal: DEFAULT_HOOKS_MODAL_ID,
            }}
            upsellButton={GainAccessButton}
        />
    );
};
